import React from 'react';
import { ThemeProvider as StyledThemeProvider, createGlobalStyle } from 'styled-components';
import { useSettings } from '../context/SettingsContext';
import theme from '../styles/theme';

// Add global styles to ensure theme consistency
const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.background.main};
    color: ${({ theme }) => theme.colors.text.primary};
    font-family: ${({ theme }) => theme.typography.fontFamily};
    margin: 0;
    padding: 0;
    transition: all 0.2s ease-in-out;
  }
`;

const ThemeProvider = ({ children }) => {
  const { state } = useSettings();
  const { settings } = state;
  
  // Use the theme from settings, or default to 'light'
  const themeMode = settings?.theme || 'light';
  
  // Get the appropriate theme based on the selected mode
  const selectedTheme = {
    ...theme,
    mode: themeMode,
    colors: {
      ...theme.colors,
      // Override colors based on theme mode
      background: {
        ...theme.colors.background,
        main: themeMode === 'dark' ? '#121212' : theme.colors.background.main,
        card: themeMode === 'dark' ? '#1e1e1e' : theme.colors.background.card,
        light: themeMode === 'dark' ? '#2d2d2d' : theme.colors.background.light
      },
      text: {
        ...theme.colors.text,
        primary: themeMode === 'dark' ? '#ffffff' : theme.colors.text.primary,
        secondary: themeMode === 'dark' ? '#b0b0b0' : theme.colors.text.secondary,
        tertiary: themeMode === 'dark' ? '#707070' : theme.colors.text.tertiary
      }
    }
  };
  
  // Ensure theme is properly structured for styled-components
  const enhancedTheme = {
    ...selectedTheme,
    // Ensure theme keys are accessible at the top level to prevent theme.theme.X errors
    typography: selectedTheme.typography,
    spacing: selectedTheme.spacing,
    breakpoints: selectedTheme.breakpoints,
    shadows: selectedTheme.shadows,
    borderRadius: selectedTheme.borderRadius,
    zIndex: selectedTheme.zIndex,
    transitions: selectedTheme.transitions,
  };
  
  console.log('Theme applied:', enhancedTheme);
  
  return (
    <StyledThemeProvider theme={enhancedTheme}>
      <GlobalStyle />
      {children}
    </StyledThemeProvider>
  );
};

export default ThemeProvider;
